/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoDestinatarioDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco dei tipi di destinatario ordinati per codice
 * @summary Elenco Tipi Destinatario
 */
export const getTipiDestinatario = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDestinatarioDTO[]>(
    {
      url: `/framework-cfg-procedimenti/tipi-destinatario`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDestinatarioQueryKey = () =>
  [`/framework-cfg-procedimenti/tipi-destinatario`] as const;

export const getGetTipiDestinatarioQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDestinatario>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiDestinatario>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDestinatario>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiDestinatarioQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDestinatario>>
  > = ({ signal }) => getTipiDestinatario(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDestinatarioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDestinatario>>
>;
export type GetTipiDestinatarioQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Tipi Destinatario
 */
export const useGetTipiDestinatario = <
  TData = Awaited<ReturnType<typeof getTipiDestinatario>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiDestinatario>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDestinatarioQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
